export default __webpack_public_path__ + "static/media/mouse.a15edfb9.svg";